import * as React from 'react';
import * as courseProgram from '../styles/courseProgram.module.scss';

export const CourseProgram = () => {
  return (
    <section className={courseProgram.courseProgram}>
      <div className={'container'}>
        <div className={`row ${courseProgram.courseProgram__wrapper}`}>
          <div className={`col-12 col-lg-6 ${courseProgram.courseProgram__description}`}>
            <h2 className={courseProgram.courseProgram__title}>
              <div className={courseProgram.courseProgram__mark}>Программа курса</div>
              включает в себя
            </h2>
            <p className={`${courseProgram.courseProgram__text} ${courseProgram.courseProgram__textOne}`}>
              Изучение слов через ассоциации.
              <br />
              Информация запоминается
              <br />
              <b>быстро и надолго.</b>
            </p>
            <p className={`${courseProgram.courseProgram__text} ${courseProgram.courseProgram__textTwo}`}>
              Все упражнения на платформе построены
              <br />
              <b>в виде увлекательного путешествия в мир воображения</b> вашего ребёнка. Так что он не только выучит
              слова, но и будет развивать мышление, логику и в целом гармонично развиваться.
            </p>
          </div>
          <div className={`col-12 col-lg-6 ${courseProgram.courseProgram__logo}`}></div>
        </div>
      </div>
    </section>
  );
};
